import React from 'react';
import useSWR from 'swr';
import { toast } from 'sonner';
import { CheckCircle2, Circle } from 'lucide-react';
import { formatDate } from '@/lib/format';
import * as T from '@/lib/tasks/service';

// Tasks the owner delegated to the signed-in user (RLS returns only those). Status only, via ot_set_status.
export function DelegatedTasks({ org }) {
  const d = useSWR(org ? ['delegated-tasks', org] : null, () => T.listTasks(org));
  const rows = (d.data || []).filter((t) => t.status !== 'cancelled');
  if (d.error || rows.length === 0) return null;
  const next = (t) => (t.status === 'open' ? 'in_progress' : t.status === 'in_progress' ? 'done' : 'open');
  const move = async (t) => { try { await T.setStatus(t.id, next(t)); d.mutate(); } catch (e) { toast.error(e.message || 'Could not update'); } };
  return (
    <div className="mt-4" data-testid="delegated-tasks">
      <div className="text-xs font-semibold uppercase tracking-wider mb-1 text-muted-foreground">Delegated to me by the owner ({rows.filter(T.isOpen).length} open)</div>
      <div className="rounded-lg border border-border bg-white divide-y divide-border">
        {rows.map((t) => (
          <div key={t.id} className="flex items-start gap-3 px-4 py-3" data-testid={`delegated-task-${t.id}`}>
            <button type="button" data-testid={`delegated-next-${t.id}`} onClick={() => move(t)} aria-label="Change status" className="mt-0.5 text-bronze">{t.status === 'done' ? <CheckCircle2 size={20} /> : <Circle size={20} />}</button>
            <div className="flex-1 min-w-0">
              <div className={`font-medium ${t.status === 'done' ? 'line-through text-muted-foreground' : ''}`}>{t.title}</div>
              {t.detail && <div className="text-sm text-muted-foreground whitespace-pre-wrap">{t.detail}</div>}
              <div className="text-xs text-muted-foreground mt-1">{T.label(T.CATEGORIES, t.category)}{t.projects?.project_code ? ` · ${t.projects.project_code}` : ''}{t.due_date ? ` · due ${formatDate(t.due_date)}` : ''} · {T.label(T.STATUSES, t.status)} — tap circle to move to {T.label(T.STATUSES, next(t))}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
